import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { getRefreshToken } from 'services/auth';
import { useGetMy } from 'api/users/use-get-my.ts';
import { useAuthStore } from 'shared/stores';

export const useInitMyUser = () => {
  const refresh = getRefreshToken();
  const [isLoading, setIsLoading] = useState(!!refresh);
  const [enabled, setEnabled] = useState(false);

  const { data, isSuccess, isError } = useGetMy(enabled);
  const { setAuth, user, isAuth, clearAuth } = useAuthStore();

  useEffect(() => {
    if (refresh) {
      setEnabled(true);
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isSuccess && data) {
      Sentry.setUser({ id: data?.id, email: data?.email });
      setAuth(data);
      setIsLoading(false);
    }
    if (isError) {
      clearAuth();
      setIsLoading(false);
    }
  }, [data, isError, isSuccess]);

  return { isLoading, user, isAuth };
};
